<template>
	<section class="blocks" id="block1" :style="{ background: bg_color }">
		<div class="container">
			<article class="article-blocks">
				<div class="right-block mobile">
					<h2 class="title-box left">{{ title }}</h2>
					<div v-html="content">
						{{ content }}
					</div>
				</div>
				<figure class="left-block desktop">
					<img :src="figure" :alt="title">
				</figure>

				<figure class="left-block mobile">
					<img :src="figure" :alt="title">
				</figure>

				<div class="right-block desktop">
					<h2 class="title-box left">{{ title }}</h2>
					<div v-html="content">
						{{ content }}
					</div>
				</div>

			</article>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color", "resp_image"]
    }
</script>

<style lang="scss">
	#block1 {

		.mobile {
			display: none;
		}

		.desktop {
			display: block;
		}

		.article-blocks {
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: space-around;

			.left-block {
				flex-basis: 50%;
			}

			.right-block {
				flex-basis: 50%;
			}

			p {
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin-bottom: 25px;
				text-align: left;
			}
		}

		figure {
			padding: 40px 0;
			text-align: center;
		}
	}

	@media (max-width: 767px) {
		#block1 {

			.mobile {
				display: block;
			}

			.desktop {
				display: none;
			}

			.article-blocks {
				flex-wrap: wrap;

				.left-block {
					flex-basis: 100%;

					img {
						width: 90%;
					}
				}

				.right-block {
					flex-basis: 100%;
				}
			}
		}
	}

	@media (max-width: 640px) {
		#block1 {

			.mobile {
				display: block;
			}

			.desktop {
				display: none;
			}

			.article-blocks {
				flex-wrap: wrap;

				.left-block {
					flex-basis: 100%;

					img {
						width: 90%;
					}
				}

				.right-block {
					flex-basis: 100%;
				}
			}
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/shared/blocks/Block1.vue